module.exports = __webpack_public_path__ + "static/actea-7f337af0037ab1a6bafb401a6b8df604.png";